export function RouteFallback() {
  return <div className="route-fallback" role="status" aria-label="页面加载中" />;
}
